import React from 'react';
import { PdfPage } from './Styles.styled';
import LCACustomResultSection from './LCACustomResultSection';
import usePdfData from './utils/usePdfData';

const LCACustomResultsPage: React.FC = () => {
  const { lcaCustomResults } = usePdfData();
  return (
    <PdfPage className="landscape">
      {lcaCustomResults.map((customResult) => (
        <LCACustomResultSection key={customResult.id} customResult={customResult} />
      ))}
    </PdfPage>
  );
};

export default LCACustomResultsPage;
